import {SwiftOnboardingService} from "./onboarding/SwiftOnboardingService";

export default function(parentModule: string): string {
    const moduleName = `${parentModule}.service`;
    return angular.module(moduleName, [])
                  .service(SwiftOnboardingService.id, SwiftOnboardingService)
                  .name;
}
